<template>
  <div class="warpper search-result-page">
    <div class="header">
      <!-- 新增：左上角返回按钮 -->
      <div class="back-btn" @click="goBack">
        <i class="el-icon-arrow-left"></i> 返回
      </div>
      <img
        class="headerImg"
        :src="require('@/assets/recycling/news/newsLogo.png')"
        alt=""
      />
      <el-input
        @keyup.enter.native="handleSearch"
        clearable
        placeholder="请输入关键字搜索新闻、价格、政务或企业..."
        v-model="form.keywords"
        class="input-with-select"
      >
        <el-button
          @click="handleSearch"
          slot="append"
          icon="el-icon-search"
        ></el-button>
      </el-input>
    </div>
    
    <div class="content search-content-container">
      <div v-if="loading" class="loading-state">
        <i class="el-icon-loading"></i> 搜索中...
      </div>
      
      <div v-else-if="!hasSearched" class="empty-state">
        <p>请输入关键字开始搜索</p>
      </div>

      <div v-else class="result-modules">
        <!-- 1. 新闻中心模块 -->
        <div class="result-module" v-if="newsResults.length > 0">
          <div class="module-header">
            <h3><i class="el-icon-news"></i> 新闻中心</h3>
            <el-button type="text" @click="goToModule('policyInformation')">查看更多 ></el-button>
          </div>
          <div class="module-list">
            <div 
              v-for="(item, index) in newsResults" 
              :key="'news-'+index" 
              class="result-item"
              @click="goToNewsDetail(item)"
            >
              <div class="item-title">{{ item.title || item.name }}</div>
              <div class="item-info">
                <span class="date">{{ item.publishTime || item.gmtCreated }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 2. 价格指数模块 -->
        <div class="result-module" v-if="priceResults.length > 0">
          <div class="module-header">
            <h3><i class="el-icon-data-line"></i> 价格指数</h3>
            <el-button type="text" @click="goToModule('priceIndex')">查看更多 ></el-button>
          </div>
          <div class="module-list">
            <div 
              v-for="(item, index) in priceResults" 
              :key="'price-'+index" 
              class="result-item"
              @click="goToPriceDetail(item)"
            >
              <div class="item-title">{{ item.wasteName || item.name }}</div>
              <div class="item-info">
                <span class="price">¥{{ item.trendData[0].price }}/{{ item.unit }}</span>
                <span class="change" :class="item.growthRatio >= 0 ? 'up' : 'down'">
                  {{ item.growthRatio >= 0 ? '+' : '' }}{{ item.growthRatio }}%
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 3. 政务服务模块 -->
        <div class="result-module" v-if="govResults.length > 0">
          <div class="module-header">
            <h3><i class="el-icon-office-building"></i> 政务服务</h3>
            <el-button type="text" @click="goToModule('government')">查看更多 ></el-button>
          </div>
          <div class="module-list">
            <div 
              v-for="(item, index) in govResults" 
              :key="'gov-'+index" 
              class="result-item"
              @click="goToGovDetail(item)"
            >
              <div class="item-title">{{ item.title }}</div>
              <div class="item-info">
                <span class="desc">{{ item.subtitle || item.brief }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 4. 企业名录模块 -->
        <div class="result-module" v-if="companyResults.length > 0">
          <div class="module-header">
            <h3><i class="el-icon-s-custom"></i> 企业名录</h3>
            <el-button type="text" @click="goToModule('industrialEcology')">查看更多 ></el-button>
          </div>
          <div class="module-list">
            <div 
              v-for="(item, index) in companyResults" 
              :key="'comp-'+index" 
              class="result-item"
              @click="goToCompanyDetail(item)"
            >
              <div class="item-title">{{ item.companyName || item.name }}</div>
              <div class="item-info">
                <span class="address">{{ item.address }}</span>
                <!-- 修改：根据枚举展示中文 -->
                <span class="type">{{ getBusinessTypeText(item.businessType) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 无结果提示 -->
        <div v-if="totalResults === 0" class="no-result">
          <img src="@/assets/recycling/index/empty.svg" alt="无结果" style="width: 150px; margin-bottom: 20px;">
          <p>未找到与 "{{ form.keywords }}" 相关的信息</p>
        </div>
      </div>
    </div>
    <bottom-url />
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import { scrollTop } from '@/util/scrollTop';
// 引入各个模块的API，假设路径如下，需根据实际项目调整
import { getPunishmentList } from '@/API/news/news.js'; 
// 假设以下API存在，如果不存在需要在对应API文件中添加搜索接口
import { getAllCategoryTrend } from '@/API/price/price.js'; 
import { getServicesEntryList } from '@/API/goverment/goverment.js';
import { getComponyList } from '@/API/compony/compony.js';

export default {
  name: 'SearchIndex',
  components: { BottomUrl },
  data() {
    return {
      form: {
        keywords: '',
      },
      loading: false,
      hasSearched: false,
      
      // 新增：业务类型枚举映射
      businessTypeMap: {
        'recycleStation': '回收网点',
        'transferStation': '中转站',
        'sortingCenter': '分拣中心',
        'wasteEnterprise': '利废企业',
        'dismantlingCenter': '二手交易市场',
        'industrialPark': '产业园区/集散市场',
        'other': '其他'
      },
      
      // 各模块搜索结果
      newsResults: [],
      priceResults: [],
      govResults: [],
      companyResults: [],
    };
  },
  computed: {
    totalResults() {
      return this.newsResults.length + this.priceResults.length + this.govResults.length + this.companyResults.length;
    }
  },
  mounted() {
    // 如果URL中有关键词，自动搜索
    const query = this.$route.query.q;
    if (query) {
      this.form.keywords = query;
      this.handleSearch();
    }
  },
  methods: {
    // 新增：返回上一页
    goBack() {
      this.$router.go(-1);
    },

    // 新增：获取业务类型中文描述
    getBusinessTypeText(type) {
      return this.businessTypeMap[type] || type || '未知类型';
    },

    async handleSearch() {
      if (!this.form.keywords.trim()) {
        this.$message.warning('请输入搜索关键字');
        return;
      }
      
      this.loading = true;
      this.hasSearched = true;
      this.newsResults = [];
      this.priceResults = [];
      this.govResults = [];
      this.companyResults = [];

      try {
        // 并行请求四个接口
        await Promise.allSettled([
          this.fetchNews(),
          this.fetchPrices(),
          this.fetchGov(),
          this.fetchCompanies()
        ]);
      } catch (error) {
        console.error('搜索出错:', error);
        this.$message.error('搜索失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    // 1. 搜索新闻
    fetchNews() {
      return getPunishmentList({ keywords: this.form.keywords }).then(res => {
        if (res.code === 200 && res.data) {
          // 假设返回结构是数组或者包含articles的对象，需根据实际API调整扁平化逻辑
          let list = [];
          if (Array.isArray(res.data)) {
             res.data.forEach(cat => {
               if(cat.articles) list.push(...cat.articles);
             });
          }
          // 取前5条展示
          this.newsResults = list.slice(0, 5);
        }
      }).catch(() => []);
    },

    // 2. 搜索价格指数 (注意：原API可能不支持关键词搜索，这里模拟过滤或调用新接口)
    fetchPrices() {
      // 假设有一个支持搜索的价格接口，或者获取全部后前端过滤（数据量大时不推荐）
      // 这里演示调用原有接口并前端简单过滤，实际应后端支持
      return getAllCategoryTrend().then(res => {
        if (res.code === 200 && res.data) {
          const keyword = this.form.keywords.toLowerCase();
          const filtered = res.data.filter(item => 
            item.wasteName && item.wasteName.toLowerCase().includes(keyword)
          );
          this.priceResults = filtered.slice(0, 5);
        }
      }).catch(() => []);
    },

    // 3. 搜索政务服务
    fetchGov() {
      return getServicesEntryList().then(res => {
        if (res.code === 200 && res.data) {
           // 同样假设需要前端过滤或后端支持，这里扁平化数据
           let list = [];
           res.data.forEach(group => {
             if(group.contents) list.push(...group.contents);
           });
           const keyword = this.form.keywords.toLowerCase();
           const filtered = list.filter(item => 
             item.title && item.title.toLowerCase().includes(keyword)
           );
           this.govResults = filtered.slice(0, 5);
        }
      }).catch(() => []);
    },

    // 4. 搜索企业名录
    fetchCompanies() {
      return getComponyList({ 
        pageNum: 1, 
        pageSize: 5, 
        keywords: this.form.keywords 
      }).then(res => {
        if (res.code === 200 && res.data && res.data.records) {
          this.companyResults = res.data.records;
        }
      }).catch(() => []);
    },

    // 跳转逻辑
    goToModule(moduleName) {
      // 跳转到对应模块首页，并带上搜索词（如果目标页面支持）
      let path = '';
      switch(moduleName) {
        case 'policyInformation': path = '/Home/policyInformation'; break;
        case 'priceIndex': path = '/Home/priceIndex'; break;
        case 'government': path = '/Home/government/homePage'; break;
        case 'industrialEcology': path = '/Home/industrialEcology'; break;
      }
      if (this.form.keywords) {
        sessionStorage.setItem('search_keyword_from_global', this.form.keywords);
      }
      
      this.$router.push({
        path: path
      });
    },

    goToNewsDetail(item) {
      // 根据新闻详情页的路由规则跳转
      // 假设需要触发 lookMyEyes 类似逻辑，或者直接路由跳转
      // 这里简化为路由跳转，具体参数需根据 policyInformation/index.vue 的逻辑调整
      if (this.form.keywords) {
        sessionStorage.setItem('search_keyword_from_global', this.form.keywords);
      }
      this.$router.push({
        path: '/Home/policyInformation',
        params: { info: { newsId: item.id, id: item.id } } // 模拟原有逻辑
      });
    },

    goToPriceDetail(item) {
      // 价格指数通常是卡片点击，可能需要设置Store或直接跳转
      if (this.form.keywords) {
        sessionStorage.setItem('search_keyword_from_global', this.form.keywords);
      }
      this.$router.push({
        path: '/Home/priceIndex',
        query: { id: item.id }
      });
    },

    goToGovDetail(item) {
       // 政务服务详情
       if (this.form.keywords) {
        sessionStorage.setItem('search_keyword_from_global', this.form.keywords);
      }
       this.$router.push({
        path: '/Home/government/homePage',
        query: { id: item.id }
      });
    },

    goToCompanyDetail(item) {
      // 企业名录详情
      if (this.form.keywords) {
        sessionStorage.setItem('search_keyword_from_global', this.form.keywords);
      }
      this.$router.push({
        path: '/Home/industrialEcology',
        query: { id: item.id }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.warpper {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
  
  .header {
    height: 200px;
    position: relative;
    width: 100%;
    background: linear-gradient(135deg, #1abe6b 0%, #159e5a 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 40px;

    // 新增：返回按钮样式
    .back-btn {
      position: absolute;
      top: 20px;
      left: 20px;
      color: white;
      font-size: 16px;
      cursor: pointer;
      display: flex;
      align-items: center;
      z-index: 10;
      
      i {
        margin-right: 5px;
        font-size: 18px;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    .headerImg {
      display: none; /* 搜索页简化头部，隐藏原Logo图或根据需要显示 */
    }

    .input-with-select {
      width: 600px;
      max-width: 90%;
      
      /deep/ .el-input__inner {
        height: 50px;
        font-size: 16px;
        border-radius: 25px 0 0 25px;
        border-right: none;
      }
      
      /deep/ .el-input-group__append {
        background-color: #159e5a;
        color: white;
        border-radius: 0 25px 25px 0;
        border-left: none;
        
        &:hover {
          background-color: #128a4d;
        }
      }
    }
  }

  .search-content-container {
    max-width: 1200px;
    margin: -30px auto 50px;
    min-height: calc(100vh - 510px);
    padding: 0 20px;
    position: relative;
    z-index: 10;
  }

  .loading-state, .empty-state, .no-result {
    text-align: center;
    padding: 50px 0;
    color: #909399;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
    
    i {
      font-size: 24px;
      margin-right: 10px;
    }
  }

  .result-modules {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .result-module {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 4px 16px 0 rgba(0,0,0,0.1);
    }

    .module-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebeef5;

      h3 {
        margin: 0;
        font-size: 18px;
        color: #303133;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 8px;
          color: #1abe6b;
        }
      }
    }

    .module-list {
      .result-item {
        padding: 12px 10px;
        border-bottom: 1px dashed #ebeef5;
        cursor: pointer;
        transition: background 0.2s;
        
        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background-color: #f5f7fa;
          
          .item-title {
            color: #1abe6b;
          }
        }

        .item-title {
          font-size: 16px;
          color: #303133;
          margin-bottom: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 500;
        }

        .item-info {
          font-size: 13px;
          color: #909399;
          display: flex;
          gap: 15px;
          
          .price {
            color: #f56c6c;
            font-weight: bold;
          }
          
          .change {
            &.up { color: #f56c6c; }
            &.down { color: #67c23a; }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .header {
    height: 150px;
  }
  
  .search-content-container {
    margin-top: -20px;
  }
  
  .result-module {
    padding: 15px;
  }
}
</style>